import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import BoxedItem from '../../../../../../components/global/BoxedItem';

const propTypes = {
  className: PropTypes.string,
};

const PhotoSearchUpgradeIosNotice = ({ className }) => {
  const classes = classNames({
    'p-3': true,
    [className]: !!className,
  });

  return (
    <BoxedItem className={classes}>
      <h3>
        How to cancel or modify a Plus subscription or trial purchased on an
        iPhone or other iOS device.
      </h3>

      <p>
        If you purchased your subscription or started a trial from your iPhone,
        iPad or other iOS device, you can cancel it by following these steps: :
      </p>

      <ol>
        <li>
          On your iOS device, tap <strong>Settings</strong>.
        </li>
        <li>Tap your name.</li>
        <li>
          Tap <strong>iTunes &amp; App Store</strong>.
        </li>
        <li>
          Tap <strong>your Apple ID</strong> at the top of the screen, then tap{' '}
          <strong>View Apple ID</strong>.
        </li>
        <li>
          Tap <strong>Subscriptions</strong> (about midway through the screen).
        </li>
        <li>
          Tap <strong>Waldo</strong>.
        </li>
        <li>
          Tap <strong>Cancel Subscription</strong> or{' '}
          <strong>Cancel Trial</strong>.
        </li>
        <li>
          Tap <strong>Confirm</strong>.
        </li>
        <li>Your account will downgrade at the end of your billing cycle.</li>
      </ol>

      <a
        href="https://support.apple.com/en-us/HT202039"
        target="_blank"
        rel="noreferrer noopener"
      >
        Learn more about cancelling your subscription on Apple’s help center
        &rarr;
      </a>
    </BoxedItem>
  );
};

PhotoSearchUpgradeIosNotice.propTypes = propTypes;

export default PhotoSearchUpgradeIosNotice;
